module.exports = __webpack_public_path__ + "img/lady.17f8f09b.svg";